import { ChatPageWrapper } from "@mirage/mosaics/Chat/components/layouts/ChatPageLayout";
import { SourcesCacheProvider } from "@mirage/mosaics/ComposeAssistant/components/workflow-agent/SourcesCacheContext";
import { AssistTemplatesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/AssistTemplatesContext";
import { ComposeAnalyticsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeAnalyticsContext";
import { ComposeSessionsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeSessionsContext";
import { ComposeVoicesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeVoicesContext";
import { ComposeCurrentSessionContextProvider } from "@mirage/mosaics/ComposeAssistant/data/current-session/ComposeCurrentSessionContext";
import { ConversationAssistantPageContent } from "./ConversationAssistantPageContent";

// Stack chat sidebar displayed on stack details page for a Dash stack.
export const StackPageChatSidebar: React.FC = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ComposeSessionsContextProvider>
        <ComposeAnalyticsContextProvider>
          <ComposeVoicesContextProvider>
            <AssistTemplatesContextProvider>
              <ChatPageWrapper>
                <ComposeCurrentSessionContextProvider>
                  <SourcesCacheProvider>
                    <ConversationAssistantPageContent
                      showModelPickerButton={false}
                      showIncognitoButton={false}
                    />
                  </SourcesCacheProvider>
                </ComposeCurrentSessionContextProvider>
              </ChatPageWrapper>
            </AssistTemplatesContextProvider>
          </ComposeVoicesContextProvider>
        </ComposeAnalyticsContextProvider>
      </ComposeSessionsContextProvider>
    </div>
  );
};
